import { useMemo, useCallback } from 'react';
import classnames from 'classnames/bind';
import { CheckIcon } from 'tuui';
import { DropdownMenu, ArrowIcon } from 'taboola-ultimate-ui';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './motionParamDropdown.module.scss';

const classNameBuilder = classnames.bind(styles);

const customStyles = {
    control: () => ({
        display: 'flex',
    }),
    placeholder: () => ({
        padding: 0,
        position: 'static',
        width: '100%',
        marginLeft: 0,
    }),
    option: baseStyle => ({
        ...baseStyle,
        whiteSpace: 'nowrap',
    }),
    menu: baseStyle => ({
        ...baseStyle,
        width: 'max-content',
        minWidth: '100%',
    }),
};

export const MotionParamDropdown = ({
    id,
    options,
    category,
    dropdownMessageId,
    dropdownMessage,
    icon: Icon,
    ariaLabel,
}) => {
    const { formatMessage } = useIntl();
    const { value: optionValue, onChange: optionOnChange } = useFormFieldValue({
        field: `motionParams.${category}`,
    });
    const selectedValueObject = useMemo(() => (optionValue == null ? null : { value: optionValue }), [optionValue]);
    const hasSelectedValue = Boolean(selectedValueObject);

    const transformedOptions = useMemo(
        () =>
            options.map(option => ({
                ...option,
                label: formatMessage({ id: option.messageId }),
            })),
        [options, formatMessage]
    );

    const valueRenderer = useCallback(() => {
        const RenderedIcon = hasSelectedValue ? CheckIcon : Icon;
        return (
            <div className={classNameBuilder('dropdown-value', { selected: hasSelectedValue })}>
                {Icon && <RenderedIcon className={classNameBuilder('dropdown-icon', { selected: hasSelectedValue })} />}
                <FormattedMessage id={dropdownMessageId} defaultMessage={dropdownMessage} />
            </div>
        );
    }, [hasSelectedValue, Icon, dropdownMessageId, dropdownMessage]);

    return (
        <DropdownMenu
            id={id}
            selectedValueObject={selectedValueObject}
            options={transformedOptions}
            onChange={({ value }) => {
                optionOnChange(value);
            }}
            placeholder={valueRenderer()}
            valueRenderer={valueRenderer}
            searchable={false}
            aria-label={ariaLabel}
            className={styles['dropdown']}
            styles={customStyles}
            arrowRenderer={() => <ArrowIcon className={classNameBuilder('dropdown-arrow')} />}
        />
    );
};
